export const services = [
  {
    id: 'sign-boards',
    title: 'Sign Boards',
    category: 'Sign Boards',
    description: 'Sign boards designed to add business value, with help on colours, design, and overall appeal.',
    image: 'https://images.unsplash.com/photo-1768490423851-31af654096c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    features: [
      'Classy design',
      'Suitable font type and size',
      'Eye-catching colours',
      'Creative theme',
      'High quality'
    ]
  },
  {
    id: 'digital-sign-boards',
    title: 'Digital Sign Boards',
    category: 'Displays',
    description: 'Digital sign boards that strengthen presence with durable builds and custom content options.',
    image: 'https://images.unsplash.com/photo-1657514027853-d162d2a09039?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    features: [
      'High optical clarity',
      'Durable and reliable',
      'Customized content',
      'Competitive technology',
      'Different patterns',
      'Longevity'
    ]
  },
  {
    id: 'led-sign-boards',
    title: 'LED Sign Boards',
    category: 'Displays',
    description: 'LED sign boards made with a focus on professional output and fit for varied business needs.',
    image: 'https://images.unsplash.com/photo-1762417582231-d4861d804c17?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    features: []
  },
  {
    id: 'road-traffic-signs',
    title: 'Road & Traffic Signs',
    category: 'Sign Boards',
    description: 'Road and traffic signs made using quality materials, checked before delivery, and customizable to requirements.',
    image: 'https://images.unsplash.com/photo-1717594722409-7809d408bec9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    features: [
      'Waterproof',
      'Low maintenance',
      'Bright and visible in low light',
      'Long life',
      'Sturdiness',
      'Easy to install',
      'Accurate dimension',
      'Flawless finish'
    ]
  },
  {
    id: 'internal-signage',
    title: 'Internal Signage Board',
    category: 'Sign Boards',
    description: 'Internal signage for guidance and communication, designed after understanding organisational needs and available in different sizes.',
    image: 'https://images.unsplash.com/photo-1767938072482-4b98997c5a27?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    features: [
      'Waterproof signboards',
      'Customized and creative',
      'LED support',
      'Professional designs',
      'High strength',
      'Easy to use',
      'Bright colors'
    ]
  },
  {
    id: 'flex-printing',
    title: 'Flex Printing',
    category: 'Printing',
    description: 'Flex printing options including normal, star, backlit, and one-way vision; built for on-time delivery and budget alignment.',
    image: 'https://images.unsplash.com/photo-1768490423851-31af654096c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    features: [
      'Customized designs',
      'Best quality material used',
      'Client centric',
      'High-quality content',
      'Appropriate use of pictures',
      'Unique color combination',
      'Available in all sizes',
      'Rock bottom rates'
    ]
  },
  {
    id: 'other-signage',
    title: 'Other Signage Boards',
    category: 'Sign Boards',
    description: 'A broad range of signage and display products including LED display boards, backlit signboards, exhibition stalls, hoardings, and more.',
    image: 'https://images.unsplash.com/photo-1765052336947-e3672c065803?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    products: [
      'Frontlit Sign Board',
      'Neon Sign Boards',
      'Backlit Sign Board',
      'Programing Led Sign Boards',
      'Pixel Led Sign Board',
      'Branding (vinyl With Foam Board)',
      'Internal Signage',
      'Open Led Sign Boards',
      'Lollipop Glow Sign Boards',
      'Acrylic Sandwich',
      'Indoor Led Display Boards',
      'Acrylic Led Sign Boards',
      'Acp Sign Boards',
      'Led Sign Board',
      'Acrylic Letters Led Signages',
      'Flute Boards Printing',
      'Acp Sign Board',
      'Pylon Sign Board',
      'Thin Led Sign Boards',
      'Crystal Led Letters & Sign Boards',
      'Ss Letters',
      'Brass Letters',
      'Laser Cutting',
      'Cnc Cutting'
    ]
  },
  {
    id: 'led-screens',
    title: 'LED Screens / Video Walls',
    category: 'Displays',
    description: 'LED screens and video walls used to reinforce brand recall in showrooms and commercial outlets.',
    image: 'https://images.unsplash.com/photo-1736994474620-fbff7ee5470c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    features: []
  },
  {
    id: 'metal-laser-cutting',
    title: 'Metal Laser Cutting',
    category: 'Fabrication',
    description: 'Laser cutting and fiber laser metal cutting services. Working area: 5 ft × 10 ft. Cutting thickness (MS): 8–10 mm.',
    image: 'https://images.unsplash.com/photo-1764114235891-66ff86abaf87?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    features: []
  }
];

export const workItems = [
  { id: 1, title: 'Sign Boards', category: 'signage', image: 'https://images.unsplash.com/photo-1768490423851-31af654096c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=600' },
  { id: 2, title: 'Internal Signage', category: 'signage', image: 'https://images.unsplash.com/photo-1767938072482-4b98997c5a27?crop=entropy&cs=srgb&fm=jpg&q=85&w=600' },
  { id: 3, title: 'Road Signs', category: 'signage', image: 'https://images.unsplash.com/photo-1717594722409-7809d408bec9?crop=entropy&cs=srgb&fm=jpg&q=85&w=600' },
  { id: 4, title: 'Flex Printing', category: 'printing', image: 'https://images.unsplash.com/photo-1768490423851-31af654096c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=600' },
  { id: 5, title: 'LED Displays', category: 'displays', image: 'https://images.unsplash.com/photo-1762417582231-d4861d804c17?crop=entropy&cs=srgb&fm=jpg&q=85&w=600' },
  { id: 6, title: 'Backlit Signage', category: 'signage', image: 'https://images.unsplash.com/photo-1765052336947-e3672c065803?crop=entropy&cs=srgb&fm=jpg&q=85&w=600' },
  { id: 7, title: 'Laser Cutting', category: 'fabrication', image: 'https://images.unsplash.com/photo-1764114235891-66ff86abaf87?crop=entropy&cs=srgb&fm=jpg&q=85&w=600' },
  { id: 8, title: 'Video Walls', category: 'displays', image: 'https://images.unsplash.com/photo-1736994474620-fbff7ee5470c?crop=entropy&cs=srgb&fm=jpg&q=85&w=600' }
];

export const categories = ['All', 'Sign Boards', 'Printing', 'Displays', 'Fabrication'];

export const processSteps = [
  {
    number: '01',
    title: 'Share requirements',
    description: 'Tell us about your signage needs, space, and budget considerations.'
  },
  {
    number: '02',
    title: 'Ideas and design direction',
    description: 'We collaborate on design concepts that align with your brand.'
  },
  {
    number: '03',
    title: 'Production',
    description: 'Your signage is crafted using quality materials and techniques.'
  },
  {
    number: '04',
    title: 'Delivery-ready output',
    description: 'Finished products checked and prepared for installation.'
  }
];
